import React, { useState, useContext, useRef, useCallback, Suspense, useEffect } from "react";
import {
	AppBar,
	CssBaseline,
	Divider,
	Drawer,
	Hidden,
	IconButton,
	List,
	ListItem,
	ListItemText,
	ListItemAvatar,
	Toolbar,
	Avatar,
	Badge,
	Menu,
	MenuItem,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	makeStyles,
	useTheme,
	withStyles,
	Popover,
	Chip,
	Tooltip
} from "@material-ui/core";
import { Breadcrumbs, Link } from "@material-ui/core";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DialogProps } from "../../../../@types/dialogProps.types";
import { api } from "../../../../utils/api";
import { io } from "socket.io-client";
import { ADMIN_ENV, port, url } from "../../../../config/config";
import { NOTIFICATION_TYPE } from "../../../../constants/notification/notificationType";
import { AuthContext, UIContext } from "../../../../contexts";
import DropDown from "../../../shared/dropDown/DropDown";
import { LazyNotifications, LazyCustomDialog } from "../../../shared";
import SIDEBAR_OPTIONS from "../../../../constants/sidebarOptions";
import { Tab } from "../../../../@types/sidebarOptions.types";
import { LazyCustomPdfViewerDialog } from "../..";
import {
	BrookshireBrothersLogo,
	IntercityDarkLogo,
	IntercityLightLogo,
	NexcaliberLightLogo,
	PanhandleFirstBankLogoWhite,
	PlanBrochurePdf,
	ProgressiveLaboratoriesLogo,
	ProgressiveLaboratoriesWhiteLogo,
	TestGroupLogoWithoutBackground,
	nexcaliberLogo
} from "../../../../assets";
import { dashboardHelpPDF } from "../../../../assets";

import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreIcon from "@material-ui/icons/MoreVert";
import PersonIcon from "@material-ui/icons/Person";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import "./employerSidebar.css";
import "./employerSidebarScroll.css";
import { PaginationQuery } from "../../../../@types/pagination.types";
import { PdfViewerDialogProps } from "../../../../@types/dialogProps.types";
import ROLES from "../../../../constants/roles";
import useRouteParam from "../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import ExtractRouteParams from "../../../../utils/commonFunctions/extractRouteParams";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";
import { useEnroller } from "../../../../hooks";
import { ENROLLER_TYPE } from "../../../../constants/enrollerType";
import { GROUP_NUMBER } from "../../../../constants/groups";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { Member } from "../../../../@types/member.types";
import dynamicSidebarOptions from "../../../shared/dynamicSideBarOptions/DynamicSidebarOptions";
import { permissions } from "../../../../permissions";
import generateImageUrl from "../../../../utils/commonFunctions/imageUrl";

const drawerWidth = 250;
// eslint-disable-next-line arrow-parens
const useStyles = makeStyles((theme) => ({
	application: {
		display: "flex"
	},
	drawer: {
		// [theme.breakpoints.up("sm")]: {
		// 	width: drawerWidth,
		// 	flexShrink: 0
		// }
	},

	appBar: {
		// [theme.breakpoints.up("sm")]: {
		// width: `calc(100% - ${drawerWidth}px)`,
		// marginLeft: drawerWidth,
		// backgroundColor: "#EEEEEE",
		// color: "black"
		// },
		// backgroundColor: "#EEEEEE",
		// color: "black"
	},
	menuButton: {
		marginRight: theme.spacing(2),
		// [theme.breakpoints.up("sm")]: {
		// display: "",
		backgroundColor: "#EEEEEE",
		color: "black"
	},
	// necessary for content to be below app bar
	toolbar: theme.mixins.toolbar,
	drawerPaper: {
		// width: drawerWidth,
		// backgroundColor: "#3A4652"
	},
	content: {
		flexGrow: 1,
		minHeight: "100vh",
		padding: theme.spacing(3)
	},
	avatarColor: {
		color: "black",
		padding: 40
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex"
		}
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none"
		}
	},
	grow: {
		flexGrow: 1
	}
}));

// eslint-disable-next-line arrow-parens
const StyledBadge = withStyles((theme) => ({
	badge: {
		backgroundColor: "#44b700",
		color: "#44b700",
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			animation: "$ripple 1.2s infinite ease-in-out",
			border: "1px solid currentColor",
			// eslint-disable-next-line quotes
			content: '""'
		}
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0
		}
	}
}))(Badge);

const EmployerSidebar = (): JSX.Element => {
	const { isEnroller, enrollerRole } = useEnroller();
	const classes = useStyles();
	const querySSN = useRouteParam("qs");
	const queryProvidersTaxId = useRouteParam("tx");
	const queryPlanCode = useRouteParam("pc");
	const theme = useTheme();
	const [isExistGroupNumber, setIsExistGroupNumber] = useState<boolean | null>(null);
	const [drawerWidth, setDrawerWidth] = useState(250);
	const queryGroupNumber = useRouteParam("gn");
	const { user, setUser } = useContext(AuthContext);
	const [mobileOpen, setMobileOpen] = useState<boolean>(false);
	const [hasFetchedAllNotifications, setHasFetchedAllNotifications] = useState<boolean>(false);
	const [limit, setLimit] = useState<number>();
	const [groupLimit, setGroupLimit] = useState<number | null>(null);
	const [isAccordionSelected, setIsAccordionSelected] = useState<boolean>(true);
	const [anchorEl, setAnchorEl] = useState<(EventTarget & (HTMLLIElement | HTMLButtonElement)) | null>(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null);
	const [popOverAnchorEl, setPopOverAnchorEl] = useState<(EventTarget & SVGSVGElement) | null>(null);
	const [accordionSelectedIndex, setAccordionSelectedIndex] = useState(null);
	const { dashboardHeader, selectedTab, setMemberUI, member, provider } = useContext(UIContext);
	const [oldNotifications, setOldNotifications] = useState<any>([]);
	const [newNotifications, setNewNotifications] = useState<any>([]);
	const [notificationCount, setNotificationCount] = useState<number | null>(null);
	const [logoutDialogProps, setLogoutDialogProps] = useState<DialogProps>({
		openDialog: false,
		title: "",
		content: "",
		actions: []
	});
	const [openPdfViewDialogProps, setOpenPdfViewDialogProps] = useState<PdfViewerDialogProps>({
		openDialog: false
	});
	const location = useLocation();
	const [drawerMenuOpen, setDrawerMenuOpen] = useState(true);
	const [showMemberName, setShowMemberName] = useState(false);
	const { setDashboardHeader } = useContext(UIContext);
	const navigate = useNavigate();
	const isMenuOpen = Boolean(anchorEl);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
	const isPopOverOpen = Boolean(popOverAnchorEl);
	const id = isPopOverOpen ? "simple-popover" : undefined;
	const [pageNumber, setPageNumber] = useState<number>(0);
	const [skeletonLoad, setSkeletonLoad] = useState<boolean>(false);
	const loading = useRef<boolean>(false);
	const [assignedGroups, setAssignedGroups] = useState([]);
	const [selectedAssignedGroup, setSelectedAssignedGroup] = useState<any>();
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)

	const [sideBarOptions, setSideBarOptions] = useState<any>([]);
	const [logoSettings, setLogoSettings] = useState<any>(null);

	const scrollToEnd = useCallback(() => {
		if (loading.current === false) {
			setPageNumber(pageNumber + 1);
		}
	}, [pageNumber]);

	const scrollEvent = useCallback(
		(event: React.UIEvent<HTMLDivElement>) => {
			const { scrollHeight, scrollTop, clientHeight } = event.target as HTMLDivElement;

			if (scrollTop + clientHeight > scrollHeight - 5) {
				scrollToEnd();
			}
		},
		[scrollToEnd]
	);

	const getNotifications = useCallback(async () => {
		const params = {
			page: pageNumber + 1,
			limit
		};
		const response = await api.notification.getNotificationsByUserId(params);
		if (response === false) {
			setHasFetchedAllNotifications(true);
			setSkeletonLoad(false);
			loading.current = false;
		}
		if (response) {
			setNewNotifications(Object.assign([], [...response.newNotifications]));
			setOldNotifications((prevOldNotification: any[]) => {
				return Object.assign([], [...prevOldNotification, ...response.oldNotifications]);
			});
			loading.current = false;
			setSkeletonLoad(false);
		}
	}, [limit, pageNumber]);

	const handlePopOverOpen = (event: React.MouseEvent<SVGSVGElement>) => {
		setPopOverAnchorEl(event.currentTarget);
		setNotificationCount(null);
		const notificationArrowElement = document.getElementById("notificationArrow");
		if (notificationArrowElement) {
			notificationArrowElement.style.display = "block";
		}
	};

	const handlePdfViewDialogOpen = useCallback(() => {
		setOpenPdfViewDialogProps(Object.assign({}, openPdfViewDialogProps, { openDialog: true }));
	}, [openPdfViewDialogProps]);

	const handlePdfViewDialogClose = useCallback(() => {
		setOpenPdfViewDialogProps(Object.assign({}, openPdfViewDialogProps, { openDialog: false }));
	}, [openPdfViewDialogProps]);

	const handlePopOverClose = useCallback(async () => {
		setPopOverAnchorEl(null);
		const notificationArrowElement = document.getElementById("notificationArrow");

		if (notificationArrowElement) {
			notificationArrowElement.style.display = "none";
		}

		const response = await api.notification.setAllNotificationsAsOldByUserId();
		if (response) {
			setOldNotifications(Object.assign([], [...response.oldNotifications]));
			setNewNotifications(Object.assign([], response.newNotifications));
		}
	}, []);

	const listenNotification = useCallback(() => {
		if (!user) {
			return;
		}
		const socket = io(`${url}:${port}`);
		// console.log("Before user return");

		socket.on(NOTIFICATION_TYPE.super_admin_sign_up, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any[]) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.registration, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.creation, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.edit, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.approval, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.member_chat_support, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.employer_chat_support, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.blogs, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.announcements, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.statement_of_understanding, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.registration_help, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.plan_creation, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.open_enrollment, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.enrollment_submission, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.terminate, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.reinstate, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});

		socket.on(NOTIFICATION_TYPE.rehire, (message: any) => {
			if (message.assingedUserIds.includes(user._id)) {
				setNewNotifications((prevNewNotifications: any) => {
					return [message, ...prevNewNotifications];
				});
			}
		});
	}, [user]);

	const getUser = useCallback(async () => {
		try {
			const response = await trackPromise(api.groupOwner.getGroupOwnerByAuth());
			// console.log("Users", response);
			let _SSN;

			const { SSN } = response;
			// Converting SSN to required type
			const ssn = String(SSN);
			if (ssn) _SSN = ssn.substring(0, 3) + "-" + ssn.substring(3, 5) + "-" + ssn.substring(5);
			if (response) {
				const _user = {
					...response,
					SSN: SSN !== "" || SSN !== undefined ? _SSN : ""
				};
				setUser(Object.assign({}, _user));
			}
		} catch (err) {
			alert("Failed to fetch User!");
		}
	}, [setUser]);

	const handleProfileMenuOpen = (event: React.MouseEvent<HTMLLIElement | HTMLButtonElement>) => {
		const { currentTarget } = event;
		setAnchorEl(currentTarget);
		const menuArrowElement = document.getElementById("menuArrow");
		if (menuArrowElement) {
			menuArrowElement.style.display = "block";
		}
	};

	const handleMobileMenuClose = () => setMobileMoreAnchorEl(null);

	const handleLogoutClick = useCallback(() => {
		setLogoutDialogProps(
			Object.assign({}, logoutDialogProps, {
				openDialog: true,
				title: "Thank you",
				content: "Do You Want to log out of Nexcaliber Portal",
				actions: [
					{
						label: "Cancel",
						callback: () => {
							// window.location.reload();
							// navigate("/login");
							setLogoutDialogProps(Object.assign({}, logoutDialogProps, { openDialog: false }));
						}
					},
					{
						label: "Okay",
						callback: () => {
							// window.location.reload();
							localStorage.removeItem("@jwt");
							navigate("/login");
							setLogoutDialogProps(Object.assign({}, logoutDialogProps, { openDialog: false }));
						}
					}
				]
			})
		);
	}, [logoutDialogProps, navigate]);

	const handleMenuClose = () => {
		setAnchorEl(null);
		const menuArrowElement = document.getElementById("menuArrow");
		if (menuArrowElement) {
			menuArrowElement.style.display = "none";
		}
		handleMobileMenuClose();
	};

	const handleMobileMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		const { currentTarget } = event;
		setMobileMoreAnchorEl(currentTarget);
	};

	const handleGroupChange = useCallback(
		(event: any) => {
			assignedGroups.forEach((group: any) => {
				if (group.group_number === event.target.value) {
					setSelectedAssignedGroup(Object.assign({}, group));
					handleRouteChange(event.target.value as number);
				}
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[selectedAssignedGroup]
	);

	const handleRouteChange = useCallback(
		(groupNumber: number) => {
			const pathname = `/employer?gn=${groupNumber}`;

			navigate(pathname);
			window.location.reload();
		},
		[navigate]
	);

	const handleDrawerToggle = useCallback(() => {
		setMobileOpen(!mobileOpen);
	}, [mobileOpen]);

	const handleDrawerMenuToggle = useCallback(() => {
		setDrawerMenuOpen(!drawerMenuOpen);
		if (drawerMenuOpen === true) {
			setDrawerWidth(0);
		} else {
			setDrawerWidth(250);
		}
	}, [drawerMenuOpen]);

	const handleMyProfileClick = useCallback(() => {
		// console.log("Employer Sidebar Role", user?.role);
		// console.log("Employer Sidebar GN", routeParam);
		let pathname;
		if (user?.role === ROLES.super_admin || user?.role === ROLES.admin) {
			pathname = "/my-profile";
		} else {
			pathname = `/employer/my-profile?${routeParam}`;
		}

		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleProfileClick = useCallback(() => {
		handleMyProfileClick();
		setAnchorEl(null);
		handleMobileMenuClose();
	}, [handleMyProfileClick]);

	const handleNameClick = useCallback(() => {
		handleMyProfileClick();
	}, [handleMyProfileClick]);

	const renderNotifications = (
		<div>
			{/* <PopoverArrow/> */}

			<Popover
				className="notification-popover"
				id={id}
				open={isPopOverOpen}
				anchorEl={popOverAnchorEl}
				onClose={handlePopOverClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center"
				}}
			>
				{/* <PopoverArrow /> */}
				<Suspense>
					<LazyNotifications
						user={user}
						newNotifications={newNotifications}
						oldNotifications={oldNotifications}
						scrollEvent={scrollEvent}
						loading={loading}
						skeletonLoad={skeletonLoad}
					/>
				</Suspense>
			</Popover>
		</div>
	);

	const menuId = "primary-search-account-menu";

	const renderMenu = (
		<Popover
			id={menuId}
			open={isMenuOpen}
			anchorEl={anchorEl}
			onClose={handleMenuClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "center"
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "center"
			}}
			style={
				{
					//scrollbar: 5
				}
			}
		>
			<div className="profile-menu">
				<List>
					<ListItem button onClick={handleProfileClick}>
						<ListItemAvatar>
							<Avatar className="list-avatar">
								<PersonIcon /* style={{ color: "#44b700" }} */ />
							</Avatar>
						</ListItemAvatar>
						<ListItemText primary="My Profile" />
					</ListItem>
					<ListItem button onClick={handleLogoutClick}>
						<ListItemAvatar>
							<Avatar className="list-avatar">
								<ExitToAppIcon /* style={{ color: "#44b700"}} */ />
							</Avatar>
						</ListItemAvatar>
						<ListItemText primary="Logout" />
					</ListItem>
				</List>
			</div>
		</Popover>
	);

	const mobileMenuId = "primary-search-account-menu-mobile";
	const renderMobileMenu = (
		<Menu
			anchorEl={mobileMoreAnchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={mobileMenuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMobileMenuOpen}
			onClose={handleMobileMenuClose}
		>
			<div className="sec-desk">
				{/* <MenuItem>
					<IconButton aria-label="show 4 new mails">
						<Badge badgeContent={4} color="secondary">
							<MailIcon style={{ color: "#4e4e4e" }} />
						</Badge>
					</IconButton>
					<p>Messages</p>
				</MenuItem> */}
				<a href="/all-notifications">
					<MenuItem>
						<IconButton aria-label="show 11 new notifications">
							<Badge badgeContent={11} color="secondary">
								<NotificationsIcon style={{ color: "#4e4e4e" }} />
							</Badge>
						</IconButton>
						<p>Notifications</p>
					</MenuItem>
				</a>
				<MenuItem onClick={handleProfileMenuOpen}>
					<IconButton
						aria-label="account of current user"
						aria-controls="primary-search-account-menu"
						aria-haspopup="true"
						color="inherit"
					>
						<AccountCircle style={{ color: "#4e4e4e" }} />
					</IconButton>
					<p>Profile</p>
				</MenuItem>
			</div>
		</Menu>
	);

	const handleBreadcrumClick = useCallback(
		async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			event.preventDefault();
			const pathname = "/";
			navigate(pathname);
		},
		[navigate]
	);

	const handleEmployerClick = useCallback(
		async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			event.preventDefault();
			const pathname = `/employer?gn=${queryGroupNumber}`;
			navigate(pathname);
		},
		[navigate, queryGroupNumber]
	);

	// const drawer = (
	// 	<div id="employer-dashboard" className="employer-dashboard">
	// 		<div className="avatar-icon-container">
	// 			<IconButton onClick={handleDrawerMenuToggle}>
	// 				<Avatar style={{ width: 24, height: 24, backgroundColor: "#558b2f" }}>
	// 					{/* <CloseIcon style={{ padding: 5 }} /> */}
	// 					<ChevronLeftIcon />
	// 				</Avatar>
	// 			</IconButton>
	// 		</div>
	// 		<div className="sidebar-logo-container">
	// 			<img
	// 				src={
	// 					queryGroupNumber === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS
	// 						? BrookshireBrothersLogo
	// 						: queryGroupNumber === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS
	// 						? IntercityDarkLogo
	// 						: queryGroupNumber === GROUP_NUMBER.PANHANDLE_FIRST_BANK
	// 						? PanhandleFirstBankLogoWhite
	// 						: queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES
	// 						? ProgressiveLaboratoriesWhiteLogo
	// 						: queryGroupNumber === GROUP_NUMBER.TEST_GROUP
	// 						? TestGroupLogoWithoutBackground
	// 						: nexcaliberLogo
	// 				}
	// 				alt="sidebar-logo-container"
	// 			/>
	// 		</div>
	// 		<div className={classes.toolbar} />

	// 		<div className="welcome-container">
	// 			<div className="dashboard-type-text" id="dashboard-type-text">
	// 				{user?.role === ROLES.employer ? (
	// 					isEnroller && enrollerRole ? (
	// 						initCapitalize(enrollerRole)
	// 					) : (
	// 						initCapitalize(ROLES.employer as string)
	// 					)
	// 				) : (
	// 					<Breadcrumbs
	// 						separator={<NavigateNextIcon fontSize="small" style={{ color: "#e0e0e0" }} />}
	// 						aria-label="breadcrumb"
	// 					>
	// 						<Link className="breadcrumb-link-text" onClick={handleBreadcrumClick}>
	// 							{user?.role !== undefined ? initCapitalize(user?.role as string) : ""}
	// 						</Link>
	// 						<span className="breadcrumb-text" onClick={handleEmployerClick}>
	// 							{initCapitalize(ROLES.employer as string)}
	// 						</span>
	// 					</Breadcrumbs>
	// 				)}
	// 			</div>
	// 			<StyledBadge
	// 				overlap="circular"
	// 				anchorOrigin={{
	// 					vertical: "bottom",
	// 					horizontal: "right"
	// 				}}
	// 				variant="dot"
	// 			>
	// 				<Avatar alt="Remy Sharp" className={classes.avatarColor}>
	// 					<div className="avatar-text">
	// 						{user && user.first_name.charAt(0) + user.last_name.charAt(0)}
	// 					</div>
	// 				</Avatar>
	// 			</StyledBadge>
	// 			<div className="welcome-text" id="welcome-text" onClick={handleNameClick}>
	// 				{user && user.first_name && user.last_name ? user.first_name + " " + user.last_name : null}
	// 			</div>
	// 			{/* <div className="avatar-icon-container">
	// 				<IconButton onClick={handleDrawerMenuToggle}>
	// 					<Avatar>
	// 						<ChevronLeftIcon />
	// 					</Avatar>
	// 				</IconButton>
	// 			</div> */}
	// 		</div>
	// 		<Divider />
	// 		<List>
	// 			{user?.role &&
	// 				SIDEBAR_OPTIONS[
	// 					queryGroupNumber === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS
	// 						? "ICI - EMPLOYER"
	// 						: queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES
	// 						? "PL - EMPLOYER"
	// 						: queryGroupNumber === GROUP_NUMBER.PANHANDLE_FIRST_BANK
	// 						? "PFB - EMPLOYER"
	// 						: isEnroller
	// 						? "BBI - ENROLLER"
	// 						: "BBI - EMPLOYER"
	// 				]?.map((tab: Tab, tabIndex: number) => {
	// 					return (
	// 						<>
	// 							{tab.subTabs.length > 0 ? (
	// 								<Accordion
	// 									className="list-item-accordion"
	// 									key={tabIndex}
	// 									style={{
	// 										display:
	// 											isEnroller &&
	// 											user?.type === ENROLLER_TYPE.agent &&
	// 											tab.caption === "Enroller Reports"
	// 												? "none"
	// 												: ""
	// 									}}
	// 								>
	// 									<AccordionSummary
	// 										expandIcon={tab.subTabs.length > 0 ? <ExpandMoreIcon /> : <div />}
	// 										aria-controls="panel1a-content"
	// 										id="panel1a-header"
	// 										className="list-item-accordion-summary"
	// 									>
	// 										<div style={{ marginRight: 10 }}>{tab.icon()}</div>
	// 										<div>{tab.caption}</div>
	// 									</AccordionSummary>
	// 									<AccordionDetails>
	// 										<List>
	// 											{tab.subTabs.length !== 0 &&
	// 												tab.subTabs.map((subTab, subTabIndex) => {
	// 													const { caption, route } = subTab;
	// 													return (
	// 														<ListItem
	// 															button
	// 															key={subTabIndex}
	// 															className="list-item-container"
	// 															onClick={() =>
	// 																navigate(`${route}?gn=${queryGroupNumber}`)
	// 															}
	// 															style={{
	// 																backgroundColor:
	// 																	selectedTab.subTabIndex === subTabIndex &&
	// 																	selectedTab.index === tabIndex
	// 																		? "#85CE36"
	// 																		: "inherit",
	// 																color:
	// 																	selectedTab.subTabIndex === subTabIndex &&
	// 																	selectedTab.index === tabIndex
	// 																		? "#4e4e4e"
	// 																		: "inherit",
	// 																fontWeight:
	// 																	selectedTab.subTabIndex === subTabIndex &&
	// 																	selectedTab.index === tabIndex
	// 																		? "bolder"
	// 																		: "inherit"
	// 															}}
	// 														>
	// 															<ListItemText
	// 																primary={caption}
	// 																className="list-item-text"
	// 																style={{
	// 																	color:
	// 																		selectedTab.subTabIndex === subTabIndex &&
	// 																		selectedTab.index === tabIndex
	// 																			? "#4e4e4e"
	// 																			: "inherit",
	// 																	fontWeight:
	// 																		selectedTab.subTabIndex === subTabIndex &&
	// 																		selectedTab.index === tabIndex
	// 																			? "bolder"
	// 																			: "inherit"
	// 																}}
	// 															/>
	// 														</ListItem>
	// 													);
	// 												})}
	// 										</List>
	// 									</AccordionDetails>
	// 								</Accordion>
	// 							) : (
	// 								<Accordion
	// 									className="list-item-accordion"
	// 									key={tabIndex}
	// 									expanded={false}
	// 									onClick={() => navigate(`${tab.route}?gn=${queryGroupNumber}`)}
	// 									style={{
	// 										display:
	// 											isEnroller &&
	// 											user?.type === ENROLLER_TYPE.agent &&
	// 											tab.caption === "Enroller Reports"
	// 												? "none"
	// 												: tab.caption === "Member Info Update" &&
	// 												  user &&
	// 												  !(
	// 														(user.first_name === "Chitrak" &&
	// 															user.last_name === "Biswas") ||
	// 														(user.first_name === "Saurabh" &&
	// 															user.last_name === "Bansode") ||
	// 														(user.first_name === "Anupam" &&
	// 															user.last_name === "Biswas") ||
	// 														(user.first_name === "Suman" &&
	// 															user.last_name === "Dutta") ||
	// 														(user.first_name === "Begum" &&
	// 															user.last_name === "Tamanna") ||
	// 														(user.first_name === "Debashis" &&
	// 															user.last_name === "Dolui") ||
	// 														(user.first_name === "Arpita" &&
	// 															user.last_name === "Chowdhury") ||
	// 														(user.first_name === "Abir" && user.last_name === "Samanta")
	// 												  ) &&
	// 												  user.role === ROLES.super_admin
	// 												? "none"
	// 												: ""
	// 									}}
	// 								>
	// 									<AccordionSummary
	// 										expandIcon={tab.subTabs.length > 0 ? <ExpandMoreIcon /> : <div />}
	// 										aria-controls="panel1a-content"
	// 										id="panel1a-header"
	// 										className="list-item-accordion-summary"
	// 									>
	// 										<div
	// 											style={{
	// 												marginRight: 10
	// 											}}
	// 										>
	// 											{tab.icon()}
	// 										</div>
	// 										<div>{tab.caption}</div>
	// 									</AccordionSummary>
	// 								</Accordion>
	// 							)}
	// 						</>
	// 					);
	// 				})}
	// 		</List>
	// 		{/* <div className="avatar-icon-container">
	// 			<IconButton onClick={handleDrawerMenuToggle}>
	// 				<Avatar>
	// 					<ChevronLeftIcon />
	// 				</Avatar>
	// 			</IconButton>
	// 		</div> */}
	// 	</div>
	// );

	// const getAssignGroups = useCallback(async () => {
	// 	const params = {
	// 		user_id: user?._id
	// 	};
	// 	const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

	// 	if (response) {
	// 		const _assignedGroups: any[] = [];
	// 		response.groupsAndLocations.forEach((group: any) => {
	// 			if (group.assigned_group_info) {
	// 				_assignedGroups.push(group);
	// 			}
	// 		});

	// 		setAssignedGroups(Object.assign([], _assignedGroups));
	// 	}
	// }, [user?._id]);

	const getAssignedGroupsCount = useCallback(async () => {
		const assignedGroupsCount = await api.assignGroupsAndLocation.getAssignedGroupsCount();

		setGroupLimit(assignedGroupsCount);
	}, []);

	const getAssignedGroups = useCallback(async () => {
		if (typeof groupLimit === "number") {
			const paginationQuery: PaginationQuery = {
				page: 1,
				limit: groupLimit
			};
			const paginatedResult = await api.assignGroupsAndLocation.getAssignedGroups(paginationQuery);
			setAssignedGroups(Object.assign([], paginatedResult.groups));
		}
	}, [groupLimit]);

	const handleInitialSelectGroup = useCallback((queryGroupNumber: number, assignedGroups: any) => {
		assignedGroups.forEach((group: any) => {
			if (group.group_number === queryGroupNumber) {
				setSelectedAssignedGroup(Object.assign({}, group));
			}
		});
	}, []);

	const getMembersByEmployeeSSN = useCallback(
		async (_employee_SSN: string, group_number: number) => {
			const findEmployeeQuery = {
				group_number,
				employee_SSN: _employee_SSN
			};
			const response: any = await trackPromise(api.member.getMembersByEmployeeSSN(findEmployeeQuery));
			// console.log("Members: ", members);
			if (response) {
				// console.log("Members + history: ", response);
				const _familyInformation: Member[] = [];
				const { memberInstance } = response;

				memberInstance.forEach((member: Member) => {
					const { role } = member;

					if (role === ROLES.employee) {
						setMemberUI(
							Object.assign(
								{},
								{
									firstName: member?.first_name,
									lastName: member?.last_name,
									role: member?.role as "EMPLOYEE" | "DEPENDENT",
									employeeId: member?.member_id
								}
							)
						);
					}
					if (role === ROLES.dependent) {
						_familyInformation.push(member as Member);
					}
				});

				// if (_familyInformation) setFamilyInformation(Object.assign([], _familyInformation));
			}
		},
		[setMemberUI]
	);

	const getGroupLogoDynamic = useCallback(async (group_number: number) => {
		try {
			const _logoSettings = await trackPromise(api.employeePageDesign.getLogoSettingsByGroupNumber(group_number));

			setLogoSettings(_logoSettings);
		} catch (error) {
			console.error("Failed to fetch logo settings", error);
			setLogoSettings(null);
		}
	}, []);

	// console.log("Selected Group", selectedAssignedGroup);

	useEffect(() => {
		setNotificationCount(newNotifications.length);
	}, [newNotifications.length]);

	useEffect(() => {
		getAssignedGroupsCount();
		getAssignedGroups();
	}, [getAssignedGroups, getAssignedGroupsCount]);

	useEffect(() => {
		if (queryGroupNumber) {
			setIsExistGroupNumber(true);
		}
	}, [queryGroupNumber, selectedAssignedGroup]);

	useEffect(() => {
		if (querySSN && !queryPlanCode) {
			setShowMemberName(true);
		}
	}, [querySSN, queryPlanCode]);

	useEffect(() => {
		if (queryGroupNumber && assignedGroups) handleInitialSelectGroup(queryGroupNumber as number, assignedGroups);
	}, [assignedGroups, handleInitialSelectGroup, queryGroupNumber]);

	useEffect(() => {
		return () => {
			listenNotification();
		};
	}, [listenNotification]);

	useEffect(() => {
		setLimit(8);
		getUser();
	}, [getUser]);

	useEffect(() => {
		if (pageNumber !== 0 && !hasFetchedAllNotifications) {
			loading.current = true;
			setSkeletonLoad(true);
		}
		if (limit && !hasFetchedAllNotifications) {
			getNotifications();
		}
	}, [getNotifications, hasFetchedAllNotifications, limit, pageNumber]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.employer_enrollment_approval);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) {
			getMembersByEmployeeSSN(querySSN as string, queryGroupNumber as number);
		}
	}, [querySSN]);

	useEffect(() => {
		if (user && queryGroupNumber) {
			(user as any).permissions[0].permission_and_subscription.permissions;

			const permission = (user as any).permissions.filter(
				(permission: any) => permission.group_number === queryGroupNumber
			);

			if (permission && permission.length > 0) {
				const sideBarOptions = dynamicSidebarOptions(
					"EMPLOYER",
					permission[0].permission_and_subscription.permissions
				);
				setSideBarOptions(sideBarOptions);
			} else {
				alert("You don't have permission to access this group number");
			}
			// console.log("user loginned", user);
		}
	}, [queryGroupNumber, user]);

	useEffect(() => {
		if (queryGroupNumber) {
			getGroupLogoDynamic(queryGroupNumber as number);
		}
	}, [queryGroupNumber, getGroupLogoDynamic]);

	const container = window !== undefined ? () => window.document.body : undefined;
	// console.log("member UI", member);
	return (
		<>
			<Suspense fallback={<div />}>
				<LazyCustomPdfViewerDialog
					dialogProps={openPdfViewDialogProps}
					handleClose={handlePdfViewDialogClose}
					pdfFile={dashboardHelpPDF}
				/>
			</Suspense>
			<div className="employer-sidebar-container" id="employer-sidebar-container">
				{isExistGroupNumber ? (
					<>
						<div className={classes.application}>
							{/* <div
							id="notificationArrow"
							className={
								window.innerWidth - document.body.clientWidth === 0
									? "employer-notificationArrowNoScroll"
									: "employer-notificationArrowWithScroll"
							}
							style={{
								display: "none"
							}}
						></div>
						<div
							id="menuArrow"
							style={{
								width: "0",
								height: "0",
								borderLeft: "7px solid transparent",
								borderRight: "7px solid transparent",
								borderBottom: "15px solid #fff",
								zIndex: 9999,
								position: "absolute",
								top: 43,
								right: 30,
								transition: "2s",
								display: "none"
							}}
						></div> */}
							{renderNotifications}
							<Suspense fallback={<div />}>
								<LazyCustomDialog
									dialogProps={logoutDialogProps}
									handleClose={() =>
										setLogoutDialogProps(
											Object.assign({}, logoutDialogProps, { openDialog: false })
										)
									}
								/>
							</Suspense>
							<CssBaseline />
							<AppBar
								position="fixed"
								className={classes.appBar}
								style={{
									width: `calc(100% - ${drawerWidth}px)`,
									marginLeft: drawerWidth,
									backgroundColor: "#EEEEEE",
									color: "black"
								}}
							>
								<Toolbar className="toolbar">
									{!drawerMenuOpen && (
										<IconButton
											color="inherit"
											aria-label="open drawer"
											edge="start"
											onClick={handleDrawerMenuToggle}
											className={classes.menuButton}
										>
											<MenuIcon />
										</IconButton>
									)}
									<div className="appbar-header" id="appbar-header">
										{dashboardHeader}
									</div>

									{location.search.includes("tx") && provider !== null ? (
										// <div className="member-naming-container" id="member-naming-container">
										// 	<Chip className="chip-container" label="Ross Porter - 010414859" />
										// </div>
										<div className="member-naming-container" id="member-naming-container">
											<Chip
												className="chip-container"
												label={
													provider.firstName + " " + provider.lastName + "-" + provider.taxId
												}
											/>
										</div>
									) : null}
									{location.search.includes("qs") && member !== null ? (
										<div className="member-naming-container" id="member-naming-container">
											<Chip
												className="chip-container"
												label={
													member.firstName +
													" " +
													member.lastName +
													(member.employeeId ? " - " + member.employeeId + " " : " ") +
													"(" +
													initCapitalize(member.role) +
													")"
												}
											/>
										</div>
									) : null}

									<div className={classes.grow} />
									<div className={classes.sectionDesktop + " sec-desk"}>
										{ADMIN_ENV === "DEV" ? (
											<div className="test-portal-container" id="test-portal-container">
												<Chip label="Test Portal" color="secondary" />
											</div>
										) : null}
										{user?.role === ROLES.super_admin || user?.role === ROLES.admin ? (
											<div className="select-group-name-container">
												{selectedAssignedGroup ? (
													<DropDown
														selectedAssignedGroup={selectedAssignedGroup}
														handleGroupChange={handleGroupChange}
														assignedGroups={assignedGroups}
													/>
												) : null}
											</div>
										) : null}
										{ADMIN_ENV === "DEV" || ADMIN_ENV === "LOCAL" ? (
											<Tooltip title="Support" enterDelay={500} leaveDelay={200}>
												<IconButton
													aria-label="help-icon"
													color="inherit"
													onClick={handlePdfViewDialogOpen}
												>
													<HelpOutlineIcon style={{ color: "#4e4e4e" }} />
												</IconButton>
											</Tooltip>
										) : null}
										<Tooltip title="Notifications" enterDelay={500} leaveDelay={200}>
											<IconButton aria-label="show new notifications" color="inherit">
												<Badge
													badgeContent={newNotifications ? notificationCount : ""}
													color="secondary"
												>
													<NotificationsIcon
														style={{ color: "#4e4e4e" }}
														onClick={handlePopOverOpen}
													/>
												</Badge>
											</IconButton>
										</Tooltip>
										<Tooltip title="Profile" enterDelay={500} leaveDelay={200}>
											<IconButton
												edge="end"
												aria-label="account of current user"
												aria-controls={menuId}
												aria-haspopup="true"
												onClick={handleProfileMenuOpen}
												color="inherit"
											>
												<AccountCircle style={{ color: "#4e4e4e" }} />
											</IconButton>
										</Tooltip>
									</div>
									<div className={classes.sectionMobile}>
										<IconButton
											aria-label="show more"
											aria-controls={mobileMenuId}
											aria-haspopup="true"
											onClick={handleMobileMenuOpen}
											color="inherit"
										>
											<MoreIcon />
										</IconButton>
									</div>
								</Toolbar>
							</AppBar>
							{renderMobileMenu}
							{renderMenu}
							<nav
								className={classes.drawer}
								aria-label="mailbox folders"
								style={{
									[theme.breakpoints.up("md")]: {
										width: drawerWidth,
										flexShrink: 0
									}
								}}
							>
								{/* <Hidden smUp implementation="css">
								<Drawer
									container={container}
									variant="temporary"
									open={mobileOpen}
									onClose={handleDrawerToggle}
									classes={{
										paper: classes.drawerPaper
									}}
									ModalProps={{
										keepMounted: true // Better open performance on mobile.
									}}
								>
									{drawer}
								</Drawer>
							</Hidden> */}
								<div>
									<Drawer
										classes={{
											paper: classes.drawerPaper
										}}
										variant="persistent"
										open={drawerMenuOpen}
										onClose={handleDrawerMenuToggle}
										ModalProps={{
											keepMounted: true // Better open performance on mobile.,
										}}
										style={{
											width: drawerWidth,
											backgroundColor: "#3A4652"
										}}
									>
										<div id="employer-dashboard" className="employer-dashboard">
											<div className="avatar-icon-container">
												<IconButton onClick={handleDrawerMenuToggle}>
													<Avatar
														style={{ width: 24, height: 24, backgroundColor: "#558b2f" }}
													>
														{/* <CloseIcon style={{ padding: 5 }} /> */}
														<ChevronLeftIcon />
													</Avatar>
												</IconButton>
											</div>
											<div className="sidebar-logo-container">
												<img
													// src={
													// 	queryGroupNumber === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS
													// 		? BrookshireBrothersLogo
													// 		: queryGroupNumber ===
													// 		  GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS
													// 		? IntercityDarkLogo
													// 		: queryGroupNumber === GROUP_NUMBER.PANHANDLE_FIRST_BANK
													// 		? PanhandleFirstBankLogoWhite
													// 		: queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES
													// 		? ProgressiveLaboratoriesWhiteLogo
													// 		: queryGroupNumber === GROUP_NUMBER.TEST_GROUP
													// 		? TestGroupLogoWithoutBackground
													// 		: nexcaliberLogo
													// }

													// Dynamic group logo
													src={
														logoSettings?.logo?.attachment
															? generateImageUrl(logoSettings.logo.attachment)
															: nexcaliberLogo
													}
													alt="sidebar-logo-container"
												/>
											</div>
											<div className={classes.toolbar} />

											<div className="welcome-container">
												<div className="dashboard-type-text" id="dashboard-type-text">
													{user?.role === ROLES.employer ? (
														isEnroller && enrollerRole ? (
															initCapitalize(enrollerRole)
														) : (
															initCapitalize(ROLES.employer as string)
														)
													) : (
														<Breadcrumbs
															separator={
																<NavigateNextIcon
																	fontSize="small"
																	style={{ color: "#e0e0e0" }}
																/>
															}
															aria-label="breadcrumb"
														>
															<Link
																className="breadcrumb-link-text"
																onClick={handleBreadcrumClick}
															>
																{user?.role !== undefined
																	? initCapitalize(user?.role as string)
																	: ""}
															</Link>
															<span
																className="breadcrumb-text"
																onClick={handleEmployerClick}
															>
																{initCapitalize(ROLES.employer as string)}
															</span>
														</Breadcrumbs>
													)}
												</div>
												<StyledBadge
													overlap="circular"
													anchorOrigin={{
														vertical: "bottom",
														horizontal: "right"
													}}
													variant="dot"
												>
													<Avatar alt="Remy Sharp" className={classes.avatarColor}>
														<div className="avatar-text">
															{user &&
																user.first_name.charAt(0) + user.last_name.charAt(0)}
														</div>
													</Avatar>
												</StyledBadge>
												<div
													className="welcome-text"
													id="welcome-text"
													onClick={handleNameClick}
												>
													{user && user.first_name && user.last_name
														? user.first_name + " " + user.last_name
														: null}
												</div>
												{/* <div className="avatar-icon-container">
					<IconButton onClick={handleDrawerMenuToggle}>
						<Avatar>
							<ChevronLeftIcon />
						</Avatar>
					</IconButton>
				</div> */}
											</div>
											<Divider />
											<List>
												{user?.role &&
													sideBarOptions["EMPLOYER"]?.map((tab: Tab, tabIndex: number) => {
														return (
															<>
																{tab.subTabs.length > 0 ? (
																	<Accordion
																		className="list-item-accordion"
																		key={tabIndex}
																		style={{
																			display:
																				// isEnroller &&
																				// user?.type === ENROLLER_TYPE.agent &&
																				// tab.caption === "Enroller Reports"
																				// 	? "none"
																				// 	:
																				""
																		}}
																	>
																		<AccordionSummary
																			expandIcon={
																				tab.subTabs.length > 0 ? (
																					<ExpandMoreIcon />
																				) : (
																					<div />
																				)
																			}
																			aria-controls="panel1a-content"
																			id="panel1a-header"
																			className="list-item-accordion-summary"
																		>
																			<div style={{ marginRight: 10 }}>
																				{tab.icon()}
																			</div>
																			<div>{tab.caption}</div>
																		</AccordionSummary>
																		<AccordionDetails>
																			<List>
																				{tab.subTabs.length !== 0 &&
																					tab.subTabs.map(
																						(subTab, subTabIndex) => {
																							const { caption, route } =
																								subTab;
																							return (
																								<ListItem
																									button
																									key={subTabIndex}
																									className="list-item-container"
																									onClick={() =>
																										navigate(
																											`${route}?gn=${queryGroupNumber}`
																										)
																									}
																									style={{
																										backgroundColor:
																											selectedTab.subTabIndex ===
																												subTabIndex &&
																											selectedTab.index ===
																												tabIndex
																												? "#85CE36"
																												: "inherit",
																										color:
																											selectedTab.subTabIndex ===
																												subTabIndex &&
																											selectedTab.index ===
																												tabIndex
																												? "#4e4e4e"
																												: "inherit",
																										fontWeight:
																											selectedTab.subTabIndex ===
																												subTabIndex &&
																											selectedTab.index ===
																												tabIndex
																												? "bolder"
																												: "inherit"
																									}}
																								>
																									<ListItemText
																										primary={
																											caption
																										}
																										className="list-item-text"
																										style={{
																											color:
																												selectedTab.subTabIndex ===
																													subTabIndex &&
																												selectedTab.index ===
																													tabIndex
																													? "#4e4e4e"
																													: "inherit",
																											fontWeight:
																												selectedTab.subTabIndex ===
																													subTabIndex &&
																												selectedTab.index ===
																													tabIndex
																													? "bolder"
																													: "inherit"
																										}}
																									/>
																								</ListItem>
																							);
																						}
																					)}
																			</List>
																		</AccordionDetails>
																	</Accordion>
																) : (
																	<Accordion
																		className="list-item-accordion"
																		key={tabIndex}
																		expanded={false}
																		onClick={() =>
																			navigate(
																				`${tab.route}?gn=${queryGroupNumber}`
																			)
																		}
																		style={{
																			display:
																				// isEnroller &&
																				// user?.type === ENROLLER_TYPE.agent &&
																				// tab.caption === "Enroller Reports"
																				// 	? "none"
																				// 	: tab.caption ===
																				// 			"Member Info Update" &&
																				// 	  user &&
																				// 	  !(
																				// 			(user.first_name ===
																				// 				"Shivpujan" &&
																				// 				user.last_name ===
																				// 					"Kumar") ||
																				// 			(user.first_name ===
																				// 				"Chitrak" &&
																				// 				user.last_name ===
																				// 					"Biswas") ||
																				// 			(user.first_name ===
																				// 				"Saurabh" &&
																				// 				user.last_name ===
																				// 					"Bansode") ||
																				// 			(user.first_name ===
																				// 				"Anupam" &&
																				// 				user.last_name ===
																				// 					"Biswas") ||
																				// 			(user.first_name ===
																				// 				"Suman" &&
																				// 				user.last_name ===
																				// 					"Dutta") ||
																				// 			(user.first_name ===
																				// 				"Begum" &&
																				// 				user.last_name ===
																				// 					"Tamanna") ||
																				// 			(user.first_name ===
																				// 				"Debashis" &&
																				// 				user.last_name ===
																				// 					"Dolui") ||
																				// 			(user.first_name ===
																				// 				"Arpita" &&
																				// 				user.last_name ===
																				// 					"Chowdhury") ||
																				// 			(user.first_name ===
																				// 				"Abir" &&
																				// 				user.last_name ===
																				// 					"Samanta")
																				// 	  ) &&
																				// 	  user.role === ROLES.super_admin
																				// 	? "none"
																				// 	:
																				""
																		}}
																	>
																		<AccordionSummary
																			expandIcon={
																				tab.subTabs.length > 0 ? (
																					<ExpandMoreIcon />
																				) : (
																					<div />
																				)
																			}
																			aria-controls="panel1a-content"
																			id="panel1a-header"
																			className="list-item-accordion-summary"
																		>
																			<div
																				style={{
																					marginRight: 10
																				}}
																			>
																				{tab.icon()}
																			</div>
																			<div>{tab.caption}</div>
																		</AccordionSummary>
																	</Accordion>
																)}
															</>
														);
													})}
											</List>
											{/* <div className="avatar-icon-container">
				<IconButton onClick={handleDrawerMenuToggle}>
					<Avatar>
						<ChevronLeftIcon />
					</Avatar>
				</IconButton>
			</div> */}
										</div>
									</Drawer>
								</div>
							</nav>
							<main className={classes.content + " main"}>
								<div className={classes.toolbar} />
								<Outlet />
							</main>
						</div>
					</>
				) : null}
			</div>
		</>
	);
};

export default EmployerSidebar;
